import {useCallback} from 'react';
import {useNavigate} from 'react-router';

import {useDocumentRepository} from '@/components/document/repository';
import {useDocumentUtils} from '@/components/document/utils';
import {APP_PATH} from '@/constants/routes';
import {SUMMARY_SECTION} from '@/constants/sections';
import {useConfig} from '@/contexts/config';
import {VisibilitySet} from '@/engine/types/document-model/document-model';
import {serializeDocumentForSignature} from '@/utils/document/serializer';

type Props = {
  visibilitySet: VisibilitySet;
};

export const useSubmitForSignature = ({visibilitySet}: Props) => {
  const navigate = useNavigate();
  const {model} = useConfig();
  const {store, valueResolver} = useDocumentUtils();
  const {submitDocumentForSignature} = useDocumentRepository();

  return useCallback(async () => {
    if (!store.getState().validity[SUMMARY_SECTION]) return;

    const state = store.getState();

    const fullDocument = serializeDocumentForSignature(
      {data: state.data, meta: state.meta},
      model,
      visibilitySet,
      valueResolver,
    );

    await submitDocumentForSignature(fullDocument, state.locale);
    await navigate(APP_PATH, {state: {isSubmitForSignature: true}});
  }, [model, navigate, store, submitDocumentForSignature, valueResolver, visibilitySet]);
};
